import { Observable, Subject } from "rxjs";
import { Component, OnDestroy, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Response } from "@angular/http";

import swal from "bootstrap-sweetalert";
import * as _ from "lodash";

import { PagedListAdapter } from "app/common/paged-list-adapter";
import { Call } from "app/models/call";
import { PagedResult } from "app/models/PagedResult";
import { CallService } from "app/services/call.service";
import { TabsetComponent } from "ngx-bootstrap";
import { PlannedServiceService } from "app/services/plannedService.service";
import { PlannedService } from "app/models/plannedService";
import { ProblemTemplateService } from "app/services/problemTemplate.service";
import { PlannedServicesShortListFilterOptions } from "app/dto/plannedServicesShortListFilterOptions";
import { Ng2selectObject } from "app/dto/ng2selectObject";
import { AuthenticationService } from "app/services/authentication.service";
import { User } from "app/models/user";
import { CallFilterOptions } from "app/dto/callFilterOptions";
import { ServiceObjectService } from "app/services/serviceObject.service";
import { ServiceObject } from "app/models/serviceObject";
import { Asset } from "app/models/asset";

@Component({
  templateUrl: './service-object-details.component.html',
  styleUrls: ['./service-object-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ServiceObjectDetailsComponent implements OnDestroy {
  @ViewChild('dropdown')
  private searchDropdown: any;

  private _serviceObject: ServiceObject;
  private _callsAdapter: ServiceObjectDetailsComponent.CallsAdapter;
  private _plannedServicesAdapter: ServiceObjectDetailsComponent.PlannedServicesAdapter;
  private _errorState: ServiceObjectDetailsComponent.ErrorState = ServiceObjectDetailsComponent.ErrorState.None;
  private _filterOptions: PlannedServicesShortListFilterOptions = new PlannedServicesShortListFilterOptions();
  private _callsFilterOptions: CallFilterOptions = new CallFilterOptions();
  public _isFinishedInTimeStatusActiveItem: Ng2selectObject;
  private _isFinishedInTimeStatusesRu: { [id: number]: string; } = { 0: "Просрочено", 1: "Не просрочено" };
  private _isFinishedInTimeStatusesSelectItems = _.map(this._isFinishedInTimeStatusesRu, function (key, value) { return new Ng2selectObject(value, key.toString()) });
  private _locationId: number;
  private _activeTabId = 0;
  private _isShowCreateCallButton: boolean;
  private _searchString: string;

  private _problemTemplateActiveItems: any[];
  private _problemTemplateSelectItems: Ng2selectObject[];

  @ViewChild('locationTabs') locationTabs: TabsetComponent;

  constructor(
    private _route: ActivatedRoute,
    private _serviceObjectService: ServiceObjectService,
    private _problemTemplatesService: ProblemTemplateService,
    private _callService: CallService,
    private _plannedServiceService: PlannedServiceService,
    private activatedRoute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private router: Router) {
    this._isShowCreateCallButton = !!(_authenticationService.authenticatedUser.permissions & User.Permissions.Write);
    this._callsAdapter = new ServiceObjectDetailsComponent.CallsAdapter(this._callService);
    this._plannedServicesAdapter = new ServiceObjectDetailsComponent.PlannedServicesAdapter(this._plannedServiceService);
    _route.params.subscribe(params => {
      this._locationId = +params['id'];
      this.loadInitData();
      this.loadLocationDetails();
    });
  }

  private loadInitData() {
    this._problemTemplatesService.getCallProblemTemplate()
      .subscribe(result => {
        this._problemTemplateSelectItems = _.map(result, function (obj) { return new Ng2selectObject(obj.id.toString(), obj.name) })
      }, err => {
        swal({
          title: 'Ошибка',
          text: 'Не удалось получить темы обращений. Попробуйте снова',
          type: 'error',
          confirmButtonText: 'Попробовать еще раз'
      }, () => {
        this.loadInitData();
        this.loadLocationDetails();
      });
      })
  }

  private loadLocationDetails() {
    this._errorState = ServiceObjectDetailsComponent.ErrorState.None;

    this._serviceObject = null

    this._serviceObjectService.getServiceObjectDetails(this._locationId)
      .subscribe(location => {
        if (location.isDeleted)
          this.router.navigateByUrl('/pagenotfound');

        this._serviceObject = location;
        this.loadPageWithUrlFilterParams();
      }, error => {
        if (error instanceof Response && (error.status == 403 || error.status == 404)) {
          this.router.navigateByUrl('/pagenotfound');
        } else {
          this._errorState = ServiceObjectDetailsComponent.ErrorState.UnknownError;
          swal({
            title: 'Ошибка',
            text: 'Не удалось получить данные объекта обслуживания. Попробуйте снова',
            type: 'error',
            confirmButtonText: 'Попробовать еще раз'
          }, () => {
            this.loadInitData();
            this.loadLocationDetails();
          });
        }
      });
  }

  private setSearchString() {
    let searchStrings: string[] = new Array();

    if (this._callsFilterOptions) {
      if (this._callsFilterOptions.problemTemplateIds != null && this._callsFilterOptions.problemTemplateIds.length > 0) {
        var problemTemplateSearchValue = _(this._problemTemplateSelectItems).keyBy('id').at(this._callsFilterOptions.problemTemplateIds).map('text').value().join('|');
        searchStrings.push("Тема:(" + problemTemplateSearchValue + ")");
      }
    }

    this._searchString = _.join(searchStrings, ' ');
  }

  private loadPageWithUrlFilterParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['activeTab'])
        this._activeTabId = +params['activeTab'];

      if (params['isFinishedInTimeStatus']) {
        this._filterOptions.isFinishedInTimeStatus = params['isFinishedInTimeStatus'];
        this._isFinishedInTimeStatusActiveItem = _.find(this._isFinishedInTimeStatusesSelectItems, function (status) { return status.id == params['isFinishedInTimeStatus']; });
      } else {
        this._filterOptions.isFinishedInTimeStatus = null;
        this._isFinishedInTimeStatusActiveItem = null;
      }

      if (params['problemTemplateIds']) {
        this._callsFilterOptions.problemTemplateIds = params['problemTemplateIds'].split(',');
        this._problemTemplateActiveItems = _(this._problemTemplateSelectItems).keyBy('id').at(this._callsFilterOptions.problemTemplateIds).value(); // Установка значений в элемент Select
      } else {

        this._problemTemplateActiveItems = [];
        this._callsFilterOptions.problemTemplateIds = null;
      }

      this.setSearchString();

      this.locationTabs.tabs[this._activeTabId].active = true;

      if (this._activeTabId == 1) {
        // обращения по локации;
        this._callsAdapter.setParams(this._locationId, this._callsFilterOptions);
      } else if (this._activeTabId == 2) {
        // ппр по локации;
        this._plannedServicesAdapter.setOptions(this._locationId, this._filterOptions);
      }
    });

  }

  ngOnDestroy(): void {
    swal.close();
  }

  private setFilterOptions(): void {
    this.setQueryParams(
      {
        problemTemplateIds: (this._problemTemplateActiveItems.length > 0) ? _.map(this._problemTemplateActiveItems, "id").join() : null,
      });
  }

  private resetFilterOptions(): void {
    this._callsFilterOptions.problemTemplateIds = null;
    this._problemTemplateActiveItems = [];
    this.setFilterOptions();
  }

  private removeProblemTemplateItem(problemTemplate: Ng2selectObject): void {
    _.remove(this._problemTemplateActiveItems, function (item) { return item.id == problemTemplate.id; });
  }

  private clearFilter() {
    this._isFinishedInTimeStatusActiveItem = null
    this.setQueryParams({ isFinishedInTimeStatus: null });
  }

  private selectFilter(value) {
    this._isFinishedInTimeStatusActiveItem = value;
    this.setQueryParams({ isFinishedInTimeStatus: this._isFinishedInTimeStatusActiveItem.id });
  }

  private selectTab(tabId: string) {
    this.setQueryParams({ activeTab: tabId });
  }

  private setQueryParams(newQueryParams: object) {
    this.router.navigate([], {
      relativeTo: this._route,
      queryParams: {
        ...this._route.snapshot.queryParams,
        ...newQueryParams
      }
    });

    this.searchDropdown.hide();
  }

  private convertAssetStatusToText(status: Asset.Status) {
    switch (status) {
      case Asset.Status.NotInstalled:
        return "Не инсталлирован";
      case Asset.Status.Installed:
        return "Инсталлирован";
      default:
        return "";
    }
  }

  private ErrorStateEnum = ServiceObjectDetailsComponent.ErrorState;
}

export namespace ServiceObjectDetailsComponent {

  export class CallsAdapter implements PagedListAdapter<Call> {
    private locationId: number;
    private filterOptions: CallFilterOptions = null;
    private _callSubject: Subject<any> = new Subject();

    constructor(
      private _callService: CallService
    ) { }

    setParams(locationId: number, filterOptions: CallFilterOptions) {
      this.locationId = locationId;
      this.filterOptions = filterOptions;
      this._callSubject.next();
    }

    getItems(count: number, skip: number, sortBy: string, isDesc: boolean): Observable<PagedResult<Call>> {
      return this._callSubject.switchMap(_ => this._callService.getPagedCallsByObjectId(this.locationId, skip, count, sortBy, isDesc, this.filterOptions));
    }
  }

  export class PlannedServicesAdapter implements PagedListAdapter<PlannedService> {
    private locationId: number;
    private _filterOptions: PlannedServicesShortListFilterOptions;
    private _plannedServiceSubject: Subject<any> = new Subject();

    constructor(
      private _plannedServiceService: PlannedServiceService,
    ) { }

    setOptions(locationId: number, filterOptions: PlannedServicesShortListFilterOptions) {
      this.locationId = locationId;
      this._filterOptions = filterOptions;
      this._plannedServiceSubject.next();
    }

    getItems(count: number, skip: number, sortBy: string, isDesc: boolean): Observable<PagedResult<PlannedService>> {
      return this._plannedServiceSubject.switchMap(_ => this._plannedServiceService.getPlanedServicesByServiceObjectPerPage(this.locationId, skip, count, sortBy, isDesc, this._filterOptions));
    }
  }

  export enum ErrorState {
    /**
     * Нет ошибок
     */
    None,
    /**
     * Сервер не может предоставить данные по объекту обслуживания (его не существует или доступ к данным запрещен)
     */
    NoData,
    /**
     * Другая ошибка
     */
    UnknownError
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/location/details/service-object-details.component.ts